var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1442",
    clipPath: "url(#clip0_1676_3793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star 2",
    d: "M21.1468 8.78116C22.0449 6.01722 25.9551 6.01722 26.8532 8.78115L28.7148 14.5106C29.1164 15.7467 30.2683 16.5836 31.568 16.5836H37.5923C40.4985 16.5836 41.7068 20.3024 39.3557 22.0106L34.4819 25.5517C33.4304 26.3156 32.9904 27.6697 33.3921 28.9058L35.2537 34.6353C36.1517 37.3992 32.9883 39.6976 30.6371 37.9894L25.7634 34.4483C24.7119 33.6844 23.2881 33.6844 22.2366 34.4483L17.3629 37.9894C15.0117 39.6976 11.8483 37.3992 12.7463 34.6353L14.6079 28.9058C15.0096 27.6697 14.5696 26.3156 13.5181 25.5517L8.64434 22.0106C6.2932 20.3024 7.50153 16.5836 10.4077 16.5836H16.432C17.7317 16.5836 18.8836 15.7467 19.2852 14.5106L21.1468 8.78116Z",
    fill: "#C1C1C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1676_3793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSilver);
export default __webpack_public_path__ + "static/media/star_silver.894e08b221dfe8935a855c945208b724.svg";
export { ForwardRef as ReactComponent };